// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function argentineCashOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'cash',
    payment_type_code: userInputValues['selectedBankCode'],
    instalments: '1',
  };
}
